<template>
	<div class="content background1" style="display: flex">
		<div class="tableBox9" v-if="!qrCodeShow">
			<div class="tableMes">
				<div class="table">
					<el-tabs v-model="activeNameTree" type="card" @tab-click="handleClickTree">
						<el-tab-pane :label="$t('label_429')" name="first">
							<tree :dataTree="treeData" :treeType="0" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
						<el-tab-pane :label="$t('label_433')" name="second">
							<tree :dataTree="treeData2" :treeType="1" @getDeviceMes="getDeviceMes"></tree>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div>
		</div>
		<div class="right-showbtn" @click="showBtn">
			<div class="right-showbtn-qrcode-background">
				<i v-if="qrCodeShow" class="el-icon-arrow-right" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
				<i v-if="!qrCodeShow" class="el-icon-arrow-left" style="margin-top: 32px; margin-left: -3px; color: #FFFFFF;"></i>
			</div>
		</div>
		<div class="tableBox10" :style="{'padding':width=='0px'?'60px 0px 0px 0px':'60px 0px 0px 350px '}">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes" v-if="getTreeMes=='1'">
						<!-- <p class="title">{{deviceDetailMes.name}}<span class="spot">点检统计</span></p> -->
						<p class="title"><span class="spot">{{deviceDetailMes.name != null ? "<" + deviceDetailMes.name + ">" : deviceDetailMes.name}}</span>{{$t('label_751')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText" style="margin-left: 10px;">
											<p>{{$t('label_752')}}</p>
										</div>
										<div class="select" style="width:380px">
											<el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" :range-separator="$t('label_264')" start-placeholder="開始日時"
											 end-placeholder="終了日時">
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<div class="spotMes3Box" style="position: relative">
							<div class="tableMin" style="height: 100%;">
								<div class="tableList" style="height: 100%;">
									<div class="buttonBox" style="float: left;margin-left: -15px;" >
<!--										<div>-->
<!--											<div class="chooseButton searchButton" @click="excel" v-if="MenuRoleList.indexOf('43')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>-->
<!--										</div>-->
                    <div>
                      <div class="chooseButton searchButton" @click="checkCountExport" v-if="MenuRoleList.indexOf('420')>=0"><i class="el-icon-download"></i>{{$t('btn_10')}}</div>
                    </div>
									</div>
									<div class="tableNum">
										<p class="p4"><img src="../../assets/img/spot/checkNum.png" style="width: 25px; height: 25px;" />
											{{statusNumList.statusAll}}</p>
										<p class="p4"><img src="../../assets/img/spot/checkStatus2.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status2}}</p>
										<p class="p4" :class="statusNumList.status3>0?'louNum':''"><img src="../../assets/img/spot/checkStatus4.png"
											 style="width: 25px; height: 25px;" /> {{statusNumList.status3}}</p>
										<p class="p4"><img src="../../assets/img/spot/checkStatus3.png" style="width: 25px; height: 25px;" />
											{{statusNumList.status4}}</p>
										<p class="p4" :class="statusNumList.AF>0?'louNum':''"><img src="../../assets/img/spot/checkAF.png" style="width: 25px; height: 25px; transform: scale(1.2);" />
											{{statusNumList.AF}}</p>
									</div>
									<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataTreeTime" highlight-current-row @current-change="handleCurrentChangeTreeTime"
									 border style="width: 102%;margin-left: -10px;" height="88%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}"
									 @row-click="handler">
										<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
										</el-table-column>
										<el-table-column prop="ename" :label="$t('label_593')" align="center">
											<template slot-scope="scope">
												<p class="tableMiTitle">
													{{scope.row.superior}}<br>
													{{scope.row.etname}} {{scope.row.ename}}<br>
													{{scope.row.code}}
												</p>
											</template>
										</el-table-column>
										<el-table-column prop="numAll" :label="$t('label_271')" align="center" width="140">
										</el-table-column>
										<el-table-column prop="num2" :label="$t('label_273')" align="center" width="140">
										</el-table-column>
										<el-table-column prop="num3" :label="$t('label_279')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.num3>0?'louNum':''">{{scope.row.num3}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="num4" :label="$t('label_281')" align="center" width="140">
										</el-table-column>
										<el-table-column prop="numAF" :label="$t('label_284')" align="center" width="140">
											<template slot-scope="scope">
												<p :class="scope.row.numAF>0?'louNum':''">{{scope.row.numAF}}</p>
											</template>
										</el-table-column>
									</el-table>
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="search"></Page>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/checkTree";
	import SpotCheck from "@/assets/js/spotCheck/spotCheck.js";
	export default {
		name: 'spotCountPage',
		components: {
			Page,
			tree,
		},
		data() {
			return {
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				Readytime: '',
				getTreeMes: '1',
				height: '',
				MenuRoleList: [],
				treeData: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '2'
				},
				treeData2: {
					dataDevice: [],
					searchShow: true,
					statusShow: false,
					statusListShow: true,
					cardShow: true,
					dataAll: true,
					funtoGetMes: '3'
				},
				deviceDetailMes: {},
				tableDataTreeTime: [],
				activeNameTree: 'second',
				statusNumList: [],
				id: '',
				width: '340px',
				qrCodeShow: false,
			}
		},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			handler(row) {
				this.id = row.equipmentId;
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.dialogSpotResult = false;
				this.dialogSpotBatchTimeEdit = false;
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			handleCurrentChangeTreeTime(info) {},
			handleClickTree(tab, event) {
				this.getTreeMes = '1';
				this.deviceDetailMes = {};
				this.search({
					pageNum: 1,
					pageSize: this.pageSize,
				});
			},
			search(param) {
				// this.Readytime = ["2021-12-01T05:49:18.184Z", "2022-01-23T05:49:18.184Z", ]
				var dataParam = {
					beginTime: this.Readytime[0],
					endTime: this.Readytime[1],
					code: this.code,
					type: this.deviceDetailMes.type,
					id: this.deviceDetailMes.id,
				}
				var newParam = Object.assign(param, dataParam);
				// this.pageNum = newParam.pageNum;
				// this.pageSize = newParam.pageSize;
				this.searchPage(newParam);
				this.searchStauts(newParam);
			},
			searchPage(param) {
			  // utils.startLoading()
				SpotCheck.getCheckCount(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTime = data.data.records
						// for (var q = 0; q < this.tableDataTreeTime.length; q++) {
						// 	this.tableDataTreeTime[q].tName = '';
						// 	this.tableDataTreeTime[q].dName = '';
						// 	for (var i = this.tableDataTreeTime[q].typeName.length - 2; i >= 0; i--) {
						// 		this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[i] + ' ';
						// 	}
						// 	this.tableDataTreeTime[q].tName += this.tableDataTreeTime[q].typeName[this.tableDataTreeTime[q].typeName.length - 1]
						// 	for (var i = this.tableDataTreeTime[q].deptName.length - 1; i >= 0; i--) {
						// 		this.tableDataTreeTime[q].dName += this.tableDataTreeTime[q].deptName[i] + ' ';
						// 	}
						// }
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
						// utils.endLoading()
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			searchStauts(param) {
				SpotCheck.getCheckStatus2(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.statusNumList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			excel() {
				if (this.id != '' && this.id != null) {
					window.location.href = this.$store.getters.getPostUrl + 'mes/equipmentCheckRecord/excel?time=' + this.Readytime[0]
						.substring(0, 7) + "&id=" + this.id;
				} else {
					utils.messageAlert(this.$t('msg_1'), this.$t('label_358'), this.$t('label_100'));
				}

			},
			getDeviceMes(data) {
				if (data.name == this.$t('label_272')) {
					this.deviceDetailMes = {};
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				} else {
					this.deviceDetailMes = data;
					this.search({
						pageNum: 1,
						pageSize: this.pageSize,
					});
				}
			},
			getNowTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates;
				return now;
			},
			getBeforeTime() {
				var time = (new Date).getTime() + 24 * 60 * 60 * 1000;
				let zeroTime = new Date(time);
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = zeroTime.getDate() < 10 ? '0' + zeroTime.getDate() : zeroTime.getDate()
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates ;
				return now;
			},
			getMonthBeginTime() {
				let zeroTime = new Date();
				let Months = zeroTime.getMonth() + 1 < 10 ? '0' + (zeroTime.getMonth() + 1) : zeroTime.getMonth() + 1; //月份从0开始，因此要+1
				let Dates = '01'
				let now = zeroTime.getFullYear() + '-' + Months + '-' + Dates ;
				return now;
			},
			showBtn() {
				this.qrCodeShow = !this.qrCodeShow;
				if (this.qrCodeShow) {
					this.width = "0px";
				} else {
					this.width = "340px";
				}
			},
      checkCountExport() {
        let dataParam = {
          beginTime: this.Readytime[0],
          endTime: this.Readytime[1],
          code: this.code,
          type: this.deviceDetailMes.type,
          id: this.deviceDetailMes.id,
        }
        SpotCheck.checkCountExport(dataParam).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = url
          link.download = decodeURIComponent(response.headers['content-disposition'].split('fileName=')[1])
          link.click()
          URL.revokeObjectURL(url)
        })
      }
		},
		created() {
			this.Readytime = [this.getMonthBeginTime(),this.getNowTime()]
			this.search({
				pageNum: 1,
				pageSize: this.pageSize
			});
			this.MenuRoleList = this.$store.getters.getMenu;
		}
	}
</script>

<style scoped>
 .buttonBox .chooseButton {
      margin-left: 5px;
  }
  .right-showbtn-qrcode-background {
  	/* position: absolute; */
  	width: 10px;
  	height: 80px;
  	background-color: #9c9c9c;
  	border-top-right-radius: 10px;
  	border-bottom-right-radius: 10px;
  	margin: auto;
  }

  .right-showbtn {
  	width: 10px;
  	height: 100%;
  	display: flex;
  	position: relative;
  	z-index: 100000;
  }
</style>



// WEBPACK FOOTER //
// src/pages/spotCheck/spotCountPage.vue